import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";

import useCanUseLocalStorage from "hooks/useCanUseLocalStorage";
import useDarkMode from "hooks/useDarkMode";

const DarkModeSlider = () => {
  const darkMode = useDarkMode(false);
  const canUseLocalStorage = useCanUseLocalStorage();

  return (
    <div className="d-flex h-100 align-items-center">
      {canUseLocalStorage ? (
        <Alert variant="danger">Cookies must be enabled</Alert>
      ) : (
        <Form.Switch
          id="dark-mode"
          checked={darkMode.value}
          label={<FontAwesomeIcon icon={darkMode.value ? "moon" : "sun"} />}
          onChange={darkMode.toggle}
        />
      )}
    </div>
  );
};

export default DarkModeSlider;
